import { render, staticRenderFns } from "./stage-list.vue?vue&type=template&id=2ebc8d74&scoped=true"
import script from "./stage-list.vue?vue&type=script&lang=js"
export * from "./stage-list.vue?vue&type=script&lang=js"
import style0 from "./stage-list.vue?vue&type=style&index=0&id=2ebc8d74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebc8d74",
  null
  
)

export default component.exports